export default {
  route: {
    dashboard: '首页',
    documentation: '文档',
    rolePermission: '角色权限',
    pagePermission: '页面权限',
    i18n: '国际化',
    profile: '个人中心',
    console: '控制台',
    menuMag: '菜单管理'
  },
  login: {
    smslogin: '短信登录',
    passwordlogin: '密码登录',
    title: '系统登录',
    logIn: '登录',
    username: '用户名',
    password: '密码',
    forgetpassword: '忘记密码',
    code: '验证码',
    codetitles: '获取验证码',
    surplus: '剩余',
    Recapture: '重新获取',
    phone: '手机号码',
    codetitle: '请输入验证码',
    zhuce: '账号注册',
    create: '创建企业',
    title1: '请输入手机号码',
    title2: '请输入密码',
    changepassword: '更换密码',
    confirmpassword: '确认密码',
    register: '注册',
    title3: '已有账号,返回',
    title4: '找回密码',
    ok: '完成',
    title5: '请输入验证码',
    title6: '请输入短信验证码',
    title7: '请输入正确的号码格式',
    title8: '请输入不少于8位数的密码',
    title9: '请输入正确手机号码',
    enterprise: '开通企业申请',
    companyname: '公司名称',
    lealperson: '法人代表',
    address: '公司地址',
    businesslicense: '营业执照',
    submit: '提交',
    rules: '请填写手机号或验证码',
    rules1: '请填写公司名称',
    rules2: '请填写法人代表',
    rules3: '请填写公司地址',
    rules4: '请上传营业执照',
    rules5: '只能上传1张图片',
    rules6: '请上传正确的图片格式',
    rules7: '上传图片大小不能超过 2MB!',
    rules8: '确认是否跳入登录页',
    rules9: '两个密码不一致',
    contactnumber: '联系电话',
    addresss: '地址',
    backLogin: '返回登录'
  },
  documentation: {
    documentation: '文档',
    github: 'Github 地址'
  },
  permission: {
    addRole: '新增角色',
    editPermission: '编辑权限',
    roles: '你的权限',
    switchRoles: '切换权限',
    tips: '在某些情况下，不适合使用 v-permission。例如：Element-UI 的 el-tab 或 el-table-column 以及其它动态渲染 dom 的场景。你只能通过手动设置 v-if 来实现。',
    delete: '删除',
    confirm: '确定',
    cancel: '取消'
  },
  guide: {
    description: '引导页对于一些第一次进入项目的人很有用，你可以简单介绍下项目的功能。本 Demo 是基于',
    button: '打开引导'
  },
  layout: {
    addMenu: '添加菜单',
    allClose: '全部收起',
    allOpen: '全部展开'
  },
  publicjs: {
    title1: '删除该文件吗',
    title2: '该记录删除后不可恢复，您确认删除吗'
  },
  public: {
    oks: '提交成功',
    tips: '提示',
    ok: '确定',
    cancel: '取消',
    upload: '上传成功',
    check: '查看',
    establish: '创建',
    download: '下载',
    edit: '编辑',
    operation: '操作',
    remarks: '备注',
    reply: '回复',
    delete: '删除',
    close: '关闭',
    reset: '重置',
    evaluate: '回复',
    save: '保存',
    cancelled: '已取消',
    search: '搜索',
    menusettings: '菜单设置',
    Adddepartment: '添加子部门',
    searchdepartment: '搜索部门',
    searchusername: '搜索用户',
    selectfile: '选取文件',
    down: '点击下载模板',
    list: '被邀请人员列表',
    memberselected: '已选择成员',
    departmentselected: '已选择部门',
    maindepartment: '主部门',
    setdepartment: '设为主部门',
    waring: '只能选择成员',
    setsuccessfully: '设置成功',
    waring2: '只能选择一个成员',
    waring3: '该人员已选择',
    modify: '修改',
    disabled: '禁用',
    enable: '启用',
    add: '添加',
    enablestatus: '启用状态',
    display: '显示',
    tipstext: '请输入名称',
    tipstext1: '请选取文件',
    tipstext2: '上传成功',
    tipstext3: '上传文件只能是 xls、xlsx格式!',
    message00: '暂无考核记录',
    message01: '暂无统计图',
    message02: '暂无考核详情',
    message03: '暂无考核计划',
    message04: '暂无考核记录',
    message05: '暂无考核模板',
    message06: '暂无员工绩效',
    message07: '暂无文件或文件夹',
    message08: '暂无待办任务',
    message09: '暂无记事本内容',
    message10: '暂无收入统计图',
    message11: '暂无支出统计图',
    message12: '暂无职位说明详情',
    message13: '暂无职位体系图',
    message14: '暂无数据',
    message15: '暂无工作分析数据',
    message16: '暂无列表数据'
  },
  navbar: {
    dashboard: '首页',
    github: '项目地址',
    logOut: '退出登录',
    profile: '个人信息',
    theme: '换肤',
    size: '布局大小',
    console: '控制台',
    tabenterprise: '切换企业',
    news: '消息',
    present: '目前没有通知'
  },
  toptable: {
    invitationtime: '邀请时间',
    entrytime: '入职时间',
    corporatelogo: '企业LOGO',
    enterprisename: '企业名称',
    state: '状态',
    operation: '操作',
    agree: '同意',
    refuse: '拒绝',
    nodata: '暂无',
    pending: '待处理',
    selecttime: '选择时间',
    startdate: '开始时间',
    to: '至',
    endingdate: '结束时间',
    all: '全部',
    today: '今天',
    yesterday: '昨天',
    day7: '最近7天',
    day30: '最近30天',
    thisweek: '本周',
    lastmonth: '上月',
    thismonth: '本月',
    thisyear: '本年',
    oneyear: '近一年',
    name: '姓名',
    department: '部门',
    worktoday: '工作总结',
    tomorrowplan: '工作计划',
    higherevaluation: '上级评价',
    updatetime: '更新时间',
    gender: '员工性别',
    pleaseselect: '请选择',
    employeestatus: '员工状态',
    accountstatus: '账号状态',
    education: '学历',
    usersearch: '员工搜索',
    title: '姓名/手机号码',
    phone: '手机号码',
    unknown: '未知',
    male: '男',
    female: '女',
    other: '其他',
    formal: '正式',
    ontrial: '试用',
    internship: '实习',
    dimission: '离职',
    normal: '正常',
    blockup: '禁用',
    operationtime: '操作时间',
    behaviorsearch: '行为搜索',
    behaviortitle: '用户行为',
    operationuser: '操作用户',
    behavior: '行为',
    link: '链接',
    loginterminal: '登录终端',
    operationip: '操作IP',
    post: '职位',
    sort: '排序',
    jointime: '加入时间',
    audit: '待审核',
    names: '名称',
    assessmentcycle: '考核周期',
    generationtime: '生成时间',
    entertime: '员工自评结束时间',
    enttime: '上级评估结束时间',
    numberexaminees: '被考核人数',
    assessor: '考核人',
    open: '开启',
    close: '关闭',
    weeklyassessment: '周考核',
    monthlyassessment: '月度考核',
    annualassessment: '年度考核',
    auditstatus: '审核状态',
    auditstatus1: '审核中'
  },
  user: {
    apply: {
      invitation: '企业邀请'
    },
    office: {
      search: '点击搜索文档',
      see: '查看文档',
      click: '点击下载'
    },
    work: {
      assessment: '我的自评',
      evaluate: '评估下级',
      all: '全部',
      backlog: '我的待办',
      done: '我的已办',
      name: '姓名',
      department: '部门',
      assessmentname: '考核名称',
      assessmenttype: '考核类型',
      weeklyassessment: '周度考核',
      monthlyassessment: '月度考核',
      annualassessment: '年度考核',
      time: '自评结束时间',
      endtime: '上级评分结束时间',
      score: '待评分',
      expired: '已过期',
      scored: '已评分',
      qssessmentscore: '考核得分',
      assessor: '考核人',
      creationtime: '创建时间',
      dispose: '处理',
      goodmorning: '上午好',
      goodafternoon: '下午好',
      performanceappraisal: '考核绩效',
      mydaily: '我的汇报',
      plan: '今天计划',
      summary: '今天总结',
      document: '企业文档',
      performanceappraisals: '绩效考核',
      the: '第',
      week: '周',
      month: '月',
      subordinatedaily: '查看汇报',
      writedaily: '填写日报',
      writedailyweek: '填写周报',
      writedailymonth: '填写月报',
      weekwork: '本周工作',
      nextweekplan: '下周计划',
      monthwork: '本月工作',
      nextmonthplan: '下月计划',
      writecomment: '填写评论',
      todaywork: '今日工作',
      tomorrowplan: '明日计划',
      title: '请填写今日工作',
      tilte1: '请填写明日计划',
      title2: '请填写内容',
      title3: '删除该成员',
      title4: '删除该条评论',
      checkdaily: '查看汇报',
      editdaily: '编辑汇报',
      dailyday: '日报',
      weekday: '周报',
      monthday: '月报',
      dailytype: '汇报类型'
    }
  },
  setting: {
    headportrait: '头像',
    name: '姓名',
    nickname: '昵称',
    title: '请填姓名',
    userid: '用户ID',
    useridtitle: '请填写用户ID',
    copy: '复制',
    copytitle: '复制成功',
    phone: '手机号码',
    phonetitle: '请填写手机号码',
    changephone: '更换手机号',
    mailbox: '邮箱',
    selectdepartment: '选择部门',
    selectadddepartment: '选择加入部门',
    invitationlink: '邀请链接',
    invitationaddlink: '生成邀请链接',
    invitationcopy: '复制链接',
    enterprise01: '直接加入企业',
    enterprise02: '需企业审核',
    enterprise03: '邀请链接有效期为7天，过期后链接即失效，需重新生成。',
    enterprise04: '，邀请您加入',
    enterprise05: '加入团队',
    enterprise06: '暂不加入',
    enterprise07: '我知道了',
    auditsucceeded: '审核成功',
    auditfailed: '审核失败',
    accountfreezing: '您的账号已被冻结',
    mailboxtitle: '请填写邮箱地址',
    box1: '邀请成员',
    box2: '批量导入成员',
    box3: '设置所在部门',
    box4: '被邀请人列表',
    box5: '必须设置一个主部门',
    box6: '邀请加入企业',
    info: {
      essentialinformation: '基本信息',
      corporatelogo: '企业logo',
      enterpriseabbreviation: '企业简称',
      enterprisecity: '企业城市',
      businessaddress: '企业地址',
      contactnumber: '联系电话',
      enterprisemembers: '企业成员',
      members: '个成员',
      businesssector: '企业部门',
      departments: '个部门',
      founder: '创建人',
      enterpriseid: '企业ID',
      enterprisestatus: '企业状态',
      deleteenterprise: '删除企业',
      disabled: '禁用',
      normal: '正常',
      behalfpayment: '代缴费',
      expired: '已过期',
      text: '一旦你删除了企业，企业内所有项目、部门、成员，项目中所有内容以及所关联的文档都将会被永久删除。这是一个不可恢复的操作，请谨慎对待！一旦你删除了企业，企业内所有项目、部门、成员，项目中所有内容以及所关联的文档都将会被永久删除。这是一个不可恢复的操作，请谨慎对待！',
      title1: '请填写企业名称',
      title2: '请填写企业地址',
      title3: '请填写联系电话',
      enterpriseinformation: '企业信息'
    },
    group: {
      text: '1. 可在组织架构中快速邀请成员，为成员设置所在部门；成员的详细信息可在',
      text2: '员工档案',
      text3: '中添加设置',
      title2: '2. 选中的部门可为其添加子部门、修改名称、删除部门，公司名称在',
      title3: '3. 删除部门需先删除此部门下的子部门及成员',
      departmentid: '部门ID',
      selectdepartment: '选择部门',
      invitationtype: '邀请类型',
      likeup: '链接邀请',
      lookup: '查找',
      accurate: '精确',
      name: '成员姓名',
      nametitle1: '请填写姓名',
      nametitle2: '请输入名称',
      phone: '手机号码',
      memberid: '成员 ID',
      memtitle: '请输入成员ID',
      addpersonnel: '添加人员',
      batchpersonnel: '批量导入人员',
      selectmember: '请选择成员',
      deletitle: '确定删除该人员吗',
      deleok: '删除成功',
      tipsid: '填写正确的成员ID号之后，经过用户同意添加为企业成员',
      delemune: '确定删除该菜单吗',
      editorialdepartment: '编辑部门',
      adddepartment: '添加部门',
      deleapply: '删除该申请人吗'
    },
    edit: {
      editorialmembers: '编辑成员',
      permissionsetting: '权限设置',
      membername: '成员姓名',
      phone: '手机号码',
      gender: '性别',
      unknown: '未知',
      male: '男',
      female: '女',
      other: '其他',
      department: '部门',
      setdepartment: '设为主部门',
      zhu: '主',
      modify: '修改',
      position: '职位',
      identity: '身份',
      ordinarymembers: '普通成员',
      executivedirector: '主管',
      text: '身份设置为主管后，自动拥有所在部门的通讯录权限',
      superiordepartment: '上级主管',
      departmenthead01: '部门负责人',
      directsuperior: '直属上级',
      administrators: '管理员',
      pleaseselect: '请选择',
      text2: '可为成员快速设置管理员拥有的权限身份，普通成员无需设置为管理员',
      selectdepartment: '选择部门',
      addmembers: '添加成员',
      text3: '请设置主部门',
      departmentname: '部门名称',
      inputcontent: '请输入部门名称',
      parentdepartment: '父级部门',
      departmenthead: '部门主管',
      selectmembers: '选择部门成员',
      departmentintroduction: '部门介绍',
      selectmembers1: '选择成员'
    },
    admin: {
      administratorstatus: '管理员身份',
      administratorlist: '管理员列表',
      text1: '1. 为企业中有跨部门管理需求的人员设置“管理员”',
      text2: '2. 此处删除成员仅删除该成员的管理员角色 ',
      text3: '3. 一个企业成员可以设置多个管理员角色',
      selectmembers: '选择成员',
      deletetitle: '删除管理员身份',
      deletetitle2: '删除该成员',
      deletetitle3: '只能选择一个成员',
      deletetitle4: '只能选择一个部门',
      deletetitle5: '不能选自己',
      Editoradministrator: '编辑管理员身份',
      identityname: '身份名称',
      addresspermissions: '管理范围',
      selectdepartment: '选择部门'
    }
  },
  hr: {
    text1: '1. 考核方案创建之后，根据考核周期会自动生成绩效考核并通知被考核人',
    text2: '2. 被考核人在多个考核方案中时，为他推送最近更新时间的考核方案，每个周期内一个被考核人只能填写一份考核表',
    text3: '3. 将员工状态改为“离职”，或其账号状态变更为“停用”时，不会为他推送考核表',
    text4: '1. 员工档案和组织架构的成员数据同步，组织架构中仅展示账号正常的员工信息',
    text5: '员工档案',
    text6: '中添加设置',
    text7: '2. 账号停用的员工不占用企业的可使用名额',
    text8: '3. 将员工状态改为“离职”时，其账号状态自动变更为“停用”；手动设置“停用”的账号，需再次手动激活才可使用，不受“员工状态”更改的影响',
    assessmentscheme: '添加考核方案',
    deletetext1: '删除该考核方案吗',
    assessmentname: '考核名称',
    inputplaceholder1: '请输入考核名称',
    inputplaceholder2: '请选择考核周期',
    inputplaceholder3: '请选择考核文档',
    inputplaceholder4: '请选择考核生成时间',
    inputplaceholder5: '请选择考核时间',
    inputplaceholder6: '请选择自评结束时间',
    inputplaceholder7: '请选择上级评分结束时间',
    inputplaceholder8: '只能输入字母',
    inputplaceholder9: '只能输入数字',
    assessmentdocument: '考核文档',
    documentset: '考核文档设置',
    assessmentstatus: '考核状态',
    enttime: '自评结束时间',
    enttimescoring: '上级评分结束时间',
    selectmembers: '选择成员',
    rules: '请输入考核名称',
    rules1: '请选择考核人员',
    rules2: '请选择被考核人员',
    rules3: '请选择考核文档',
    rules4: '请选择考核文档设置',
    rules5: '请选择生成时间',
    rules6: '请选择自评结束时间',
    rules7: '请选择上级评分结束时间',
    rules8: '只能添加一个考核人员',
    weeklyassessment: '周考核',
    monthlyassessment: '月考核',
    annualassessment: '年考核',
    monday: '星期一',
    tuesday: '星期二',
    wednesday: '星期三',
    thursday: '星期四',
    friday: '星期五',
    saturday: '星期六',
    sunday: '星期天',
    month: '本月',
    nextmonth: '下个月',
    year: '今年',
    nextyear: '明年',
    name: '名称',
    nametext: '请填名称',
    abscissa: '横坐标',
    abscissatexte: '请输入横坐标,只能填字母',
    abscissatext: '只能输入字母',
    ordinate: '纵坐标',
    ordinatetexte: '请输入纵坐标,只能填数字',
    ordinatext: '只能输入数字',
    positionstatus: '任职状态',
    dimission: '离职',
    onob: '在职',
    deletetitle: '删除该经历吗',
    deletetitle1: '删除该调薪记录吗',
    placeholder: '请填写员工姓名',
    placeholder1: '请填写手机号码',
    placeholder2: '请填写身份证号',
    placeholder3: '请选择性别',
    placeholder4: '选择日期',
    placeholder5: '请选择民族',
    placeholder6: '请填写政治面貌',
    placeholder7: '请填写学历',
    placeholder8: '请填写学位',
    placeholder9: '请填写籍贯',
    placeholder10: '请填写居住地址',
    placeholder11: '请选择',
    placeholder12: '请填写紧急联系人',
    placeholder13: '请填写紧急联系电话',
    placeholder14: '请填写邮箱',
    placeholder15: '请填写排序',
    placeholder16: '请填写职位',
    placeholder17: '请选择管理员',
    placeholder18: '请设置主部门',
    placeholder19: '请选择员工状态',
    employeename: '员工姓名',
    phonenumber: '手机号码',
    idnumber: '身份证号',
    gender: '性别',
    unknown: '未知',
    male: '男',
    female: '女',
    other: '其他',
    datebirth: '出生日期',
    age: '年龄',
    nation: '民族',
    politicaloutlook: '政治面貌',
    highesteducation: '最高学历',
    highestdegree: '最高学位',
    nativeplace: '籍贯',
    currentresidence: '现居地',
    maritalstatus: '婚姻状况',
    unmarried: '未婚',
    married: '已婚',
    workinghours: '参加工作时间',
    emergencycontact: '紧急联系人',
    emergencycontactnumber: '紧急联系电话',
    contactemail: '联系邮箱',
    sort: '排序',
    accountstatus: '账号状态',
    normal: '正常',
    blockup: '停用',
    tipstetx: '账号停用后，员工将不能登录企业后台',
    formal: '正式',
    ontrial: '试用',
    internship: '实习',
    tablist1: '个人信息',
    tablist2: '职工信息',
    tablist3: '个人经历',
    tablist4: '绩效薪酬',
    employeestatus: '员工状态',
    entrytime: '入职时间',
    department: '部门',
    setup: '设为主部门',
    zhu: '(主)',
    position: '职位',
    administrators: '管理员',
    trialtime: '试用时间',
    positivetime: '转正时间',
    timeexpiration: '合同到期时间',
    workingexperience: '任职经历',
    addexperience: '添加经历',
    workexperience: '工作经历',
    educationalexperience: '教育经历',
    company: '公司',
    jobdescription: '工作描述',
    reasonsleaving: '离职原因',
    admissiontime: '入学时间',
    graduationtime: '毕业时间',
    schoolname: '学校名称',
    major: '专业',
    education: '学历',
    degree: '学位',
    date: '日期',
    selectdepartment: '选择部门',
    documentsearch: '文档搜索',
    newdocument: '新建文档',
    importdocuments: '导入文档',
    searchdocuments: '搜索文档',
    searchcategories: '搜索分类',
    addcategory: '添加分类',
    documentcover: '文件封面',
    filename: '文件名称',
    founder: '创建人',
    template: '模板',
    astemplate: '可作模板',
    nottemplate: '不可作为模板',
    state: '状态',
    display: '显示',
    hide: '隐藏',
    updatetime: '更新时间',
    download: '下载',
    editdocument: '编辑文档',
    sharelist: '分享列表',
    addpermission: '添加权限',
    deletetitle2: '确定删除该文档吗',
    deleteok: '删除成功',
    more: '更多',
    documentname: '文档名称',
    placeholder20: '填写文档名称',
    documenttype: '文档类型',
    placeholder21: '选择文档类型',
    documentcovers: '文档封面',
    placeholder22: '上传文档封面',
    open: '开启',
    close: '关闭',
    placeholder23: '请上传正确的图片格式',
    uploadfile: '上传文件',
    Partnotuploaded: '部分未上传',
    uploadcomplete: '上传完成',
    clickview: '点击查看',
    importlist: '导入列表',
    documentformat: '文档格式',
    documentsize: '文档大小',
    success: '成功',
    fail: '失败',
    placeholder24: '请上传文件',
    names: '姓名',
    sharepeoplelist: '分享人员列表',
    modifyandview: '修改和查看',
    viewonly: '仅查看',
    deletetitle3: '删除该人员吗',
    selectuser: '选择用户',
    adduser: '请添加用户',
    addagain: '重新添加',
    type: '类型',
    jobsearch: '职位搜索',
    placeholder25: '请输入职位名称',
    addposition: '添加职位',
    viewpositionmap: '查看职位图',
    jobtitle: '职位名称',
    immediatesuperior: '职位类别',
    toplevel: '顶级',
    numberPosts: '职位人数',
    jobdescriptions: '职责简介',
    joboetails: '职位详情',
    creationtime: '创建时间',
    jobresponsibilities: '职位职责',
    message: '请填写职位名称',
    message1: '请输入名称',
    message2: '请输入职位简介',
    message3: '删除该职位吗',
    message4: '请选择上级职位',
    message5: '请选择职位级别',
    message6: '确定删除该类别吗',
    message7: '确定删除该类型吗',
    jobdescriptiones: '职位简介',
    postsupervisor: '职位职级名称上级',
    higherposition: '上级职位',
    editorialpost: '编辑职位',
    addcategorys: '添加类别',
    rankcategoryname: '职级类别名称',
    ranknumber: '职级数',
    prerankcategories: '前置职级类别',
    addtype: '添加类型',
    addrank: '添加职级',
    rankname: '职级名称',
    numberranks: '职级人数',
    prerankrequirements: '前置职级要求',
    positionlevel: '职位级别',
    ranktype: '职级别名',
    rank: '职级',
    message8: '请选择职级别名',
    message9: '请选择职级',
    ranktypes: '职级类别'
  },
  finance: {
    entrytime: '收支时间',
    accounttype: '记账类型',
    pleaseselect: '请选择',
    pleaseinput: '请输入',
    accountinputdate: '选择日期:',
    accountselectdate: '请选择日期',
    paytype: '支付方式',
    all: '全部',
    income: '收入',
    pay: '支出',
    accountname: '账目名称',
    addposition: '新增账目',
    addpositionTitle: '新建账目',
    accounttabtitle: '账目类型',
    accounttabtype: '账目分类',
    accountnumber: '账目金额',
    pleasenumber: '请输入账目金额',
    accounttabremark: '备注信息',
    pleaseremark: '请输入备注信息',
    accounttabmoney: '金额(元)',
    accountpay: '支付方式',
    accounttabsubject: '会计科目',
    keeptype: '记账类型:',
    keepitem: '记账分类:',
    addpositionType: '新增分类',
    message3: '你确定要删除账目分类吗',
    message4: '你确定要删除资金记录吗',
    message5: '删除后，对应的合同付款及收支记账也会删除',
    pleaseinput1: '请输入账目分类',
    businesstrends: '营业趋势',
    incometrends: '收入占比分析',
    expendtrends: '支出占比分析',
    switchstyles: '切换样式',
    noselect: '不选',
    mode: '支付方式',
    batchupload: '导入',
    batchexport: '导出',
    exporttemplate: '导出上传模板',
    serialnumber: '序号',
    type: '类型',
    amountmoney: '金额',
    proportion: '占比率',
    other: '其它',
    revenueamount: '收入金额',
    expenditureamount: '支出金额',
    totalrevenue: '总收入',
    totalexpenditure: '总支出',
    sourceincome: '收入来源',
    sourceexpenditure: '支出去向',
    one: '一级',
    two: '二级',
    three: '三级'
  },
  access: {
    selectexaminee: '选择被考核人',
    selecteassessmenttype: '选择考核类型',
    adddimension: '添加考核维度',
    addtarget: '套用考核模板',
    targetname: '指标名称',
    placeholder01: '输入指标名称',
    targetexplain: '指标说明',
    placeholder02: '输入指标说明',
    addTarget01: '选择指标库',
    addTarget02: '添加指标',
    weight: '权重',
    selecttemplate: '选择模板',
    settemplate: '设置模板',
    edittemplate: '编辑模板',
    savedraft: '保存草稿',
    saveandsubmit: '保存',
    dimensionname: '维度名称',
    dimensionweight: '维度权重',
    dimensionscore: '维度分数',
    targetibrary: '指标模板库',
    appraisallibrary: '考核模板库',
    templatename: '模板名称',
    templatecontent: '模板简介',
    templatetype: '模板分类',
    selecttemplatetype: '选择模板分类',
    openassessmenttype: '请开启考核类型',
    placeholder03: '考核维度名称为空',
    placeholder04: '考核维度权重为空',
    placeholder05: '考核模板名称为空',
    placeholder06: '考核模板内容为空',
    placeholder07: '请选择模板分类',
    placeholder09: '填写指标名称',
    placeholder10: '填写指标内容',
    placeholder11: '填写指标权重',
    placeholder12: '考核维度不能为空',
    placeholder13: '考核维度权重必须为100',
    placeholder14: '考核类型不能为空',
    placeholder15: '考核时间不能为空',
    scoreshows: '评分说明',
    scoretype: '评分方式',
    scoretype1: '加和评分',
    scoretype2: '加权评分',
    placeholder16: '请输入内容',
    classname: '等级名称',
    fractionalrange: '分数区间范围',
    levelthat: '等级说明',
    score: '分数',
    inputthescore: '输入分数',
    placeholder17: '输入等级',
    addarating: '添加等级',
    tips01: '您确定要删除这条记录吗',
    tips02: '分数区间值不能空',
    tips03: '分数区间值不能小于等于最小值',
    tips04: '等级名称不能为空',
    tips05: '等级说明不能为空',
    openstatus: '开启状态',
    goalsettingtime: '目标制定时间',
    numberofdays: '请输入天数',
    day: '天',
    superiorevaluationtime: '上级评价时间',
    performancereviewtime: '绩效审核时间',
    assessee: '被考核人员',
    beforetheexamination: '考核开始前',
    aftertheexaminationbegins: '考核开始后',
    beforetheendofassessment: '考核结束前',
    aftertheexamination: '考核结束后',
    superiorevaluation: '上级评价结束后',
    tips06: '请填写名称',
    tips07: '请填写目标定制天数',
    tips08: '请填写上级评价天数',
    tips09: '请填写上级审核天数',
    theinspectionplan: '考核计划',
    evaluationscore: '考核评分',
    assessmentprocess: '考核流程',
    tips10: '请添加内容',
    completion: '完成情况 (自评)',
    completion1: '自评分',
    higherevaluation: '上级评价',
    degree: '完成度 (自评)',
    inputcompletion: '输入完成情况',
    superiorgrade: '上级评分',
    hiddennote: '隐藏备注',
    myremark: '我的备注',
    tips11: '你确定要提交考核吗',
    tips12: '填写考核备注信息，此信息仅自己可见',
    totalscore: '总分',
    totalscore1: '当前得分',
    rejectcomplaint: '驳回申诉',
    percomplaint: '绩效申诉',
    tips13: '请输入驳回理由',
    tips14: '请输入申诉理由',
    dealwith: '已处理',
    hasbeenrejected: '已驳回',
    processing: '处理中',
    toscore: '重新打分',
    tips15: '未选择被考核人时默认全员参与',
    createassessment: '创建考核',
    assessmentgrade: '考核等级',
    enabled: '已启用',
    notenabled: '未启用',
    starttime: '考核开始时间',
    endtime: '考核结束时间',
    scoringrecord: '评分记录',
    tips16: '启用后，被考核人将会看到考核，确定开启吗',
    agencymatters: '待办事项',
    examinee: '被考核人',
    placeholder18: '请选择被考核人',
    placeholder19: '请选择考核状态',
    currentassessment: '当前考核',
    selfassessment: '我的自评',
    selfassessment01: '我的考核',
    subordinateassessment: '查看考核',
    performancereview: '绩效审核',
    mydepartment: '我的部门',
    selectpersonnel: '选择人员',
    employees: '在职员工',
    newemployees: '未入职员工',
    resignedemployees: '离职员工',
    goalsetting: '目标制定',
    executionphase: '执行期',
    performancegrievance: '绩效申诉',
    end: '结束',
    directsuperior: '直接上级',
    reviewer: '审核人',
    supervisor: '监督人',
    placeholder20: '高级领导为考核人的直接上级，指定人员为多人时，一人同意或驳回即生效',
    participants: '参与人',
    applicant: '申请人',
    required: '必填项',
    jurisdiction: '权限',
    adjustscore: '调整分数',
    assessmentscore: '考核分数',
    superiorcomments: '上级评语',
    placeholder21: '必须指定至少一个人员',
    placeholder22: '选择执行人',
    assessemployees: '考核员工',
    assessmentstatistics: '考核统计',
    deleterecord: '删除记录',
    return: '返回',
    start: '开始',
    placeholder23: '选择考核人',
    assessmenttime: '考核时间',
    ren: ' 人',
    ci: ' 次',
    assessmentdetails: '考核详情',
    deletereason: '删除原因',
    deleteperson: '删除人',
    placeholder24: '暂无内容可导出',
    performanceexport: '绩效导出'
  },
  file: {
    placeholder01: '搜索文件名称',
    commonfiles: '常用文件',
    enterprisespace: '企业空间',
    lately: '最近编辑',
    collection: '我的收藏',
    share: '共享',
    myfiles: '我的文件',
    commonfolders: '常用文件夹',
    recyclebin: '回收站',
    spacesettings: '空间设置',
    spatialediting: '空间编辑',
    placeholder02: '你确定要删除该空间吗',
    spacename: '空间名称',
    placeholder03: '输入空间名称',
    addmember: '添加成员',
    spacemember: '空间成员',
    batchsettings: '批量设置',
    placeholder04: '请添加分享成员',
    moveto: '移动至',
    shareme: '共享给我',
    myshare: '我的共享',
    newlybuild: '新建',
    upload: '上传',
    restorefile: '恢复文件',
    completelydelete: '彻底删除',
    returnspace: '返回企业空间',
    filename: '文件名称',
    updatetime: '更新时间',
    creationtime: '创建时间',
    filesize: '文件大小',
    deletetime: '删除时间',
    order: '升序',
    desc: '降序',
    type: '类型',
    document: '文档',
    ppt: '幻灯片',
    picture: '图片',
    table: '表格',
    newdocument: '新建文档',
    newtable: '新建表格',
    newslide: '新建幻灯片',
    documenttemplates: '使用文档模板',
    newfolder: '新建文件夹',
    selecttemplate: '选择模板',
    allfiles: '全部文件',
    placeholder05: '请选择要删除的内容',
    placeholder06: '请选择要恢复的内容',
    placeholder07: '请选择要移动的内容',
    detailedinformation: '详细信息',
    filetype: '文件类型',
    folder: '文件夹',
    filelocation: '文件位置',
    allpositions: '全部位置',
    modificationtime: '修改时间',
    reverse: '反选',
    all: '全选',
    total: '共',
    individual: '个',
    setcommon: '设为常用',
    cancelcommon: '取消常用',
    cancelcollection: '取消收藏',
    placeholder08: '搜索文件模板',
    filesharing: '文件共享',
    addsharedmembers: '添加共享成员',
    selectsharer: '选择共享人',
    placeholder09: '你确定要取消共享吗',
    placeholder10: '请输入文件名称',
    myauthority: '我的权限',
    sharer: '共享人',
    editable: '可编辑',
    readonly: '只读',
    people: '人',
    sharingsettings: '共享设置',
    cancelsharing: '取消共享',
    copyto: '复制到',
    rename: '重命名',
    attribute: '属性',
    fileattribute: '文件属性',
    usetemplate: '使用模板',
    placeholder11: '搜索文件模板',
    placeholder12: '请选择使用模板内容',
    directory: '目录权限',
    setdirectory: '设置目录权限'
  },
  customer: {
    addtype: '添加分类',
    edittype: '编辑分类',
    typename: '分类名称',
    labelname: '标签名称',
    message01: '你确定要删除该分类吗',
    addlabel: '添加标签组',
    editlabel: '编辑标签组',
    labelename: '标签组名称',
    label: '标签',
    setlabel: '设置标签',
    transfer: '转移',
    invoicerange: '发票范围:',
    invoicesearch: '发票搜索：',
    invoiceapply: '申请发票',
    invoiceedit: '发票编辑',
    placeholder01: '请输入关键字搜索',
    placeholder02: '选择发票范围',
    placeholder03: '请输入分类名称',
    placeholder04: '请输入排序',
    placeholder05: '请输入标签名称',
    contractname: '合同名称',
    contractstatus: '合同状态',
    abnormal: '异常',
    execution: '进行中',
    finished: '已结束',
    notstarted: '未开始',
    contractstatus1: '请选择合同状态',
    enddate: '结束日期',
    startdate: '开始日期',
    invoicname: '发票名称',
    contractpay: '合同金额(元)',
    invoicingpay: '开票金额(元)',
    invoicingdate: '期望开票日期',
    invoicingtype: '开票类型',
    accessstatus: '审核状态',
    actualdate: '实际开票日期',
    salesman: '业务员',
    creationtime: '创建时间',
    message02: '内容不能为空',
    message03: '你确定要删除该数据吗',
    message04: '该标签可能已经关联客户，您确认要删除吗',
    customersource: '客户来源',
    renewaltype: '续费类型',
    addmodel: '添加类型',
    placeholder06: '请输入类型',
    message05: '名称不能为空',
    placeholder07: '请输入客户名称',
    placeholder08: '请选择客户来源',
    placeholder09: '请输入手机号码',
    placeholder10: '请输入邮箱地址',
    placeholder11: '请选择客户标签',
    placeholder12: '请选择客户分类',
    placeholder13: '请输入详情地址',
    placeholder14: '请输入联系人姓名',
    placeholder15: '请输入联系人电话号码',
    placeholder16: '请输入联系人邮箱',
    placeholder17: '请输入联系人职位',
    placeholder18: '请填写备注信息',
    placeholder19: '请选择城市',
    customername: '客户名称',
    customeremail: '邮箱',
    customerlabel: '客户标签',
    customertype: '客户分类',
    areas: '省市区',
    detailedaddress: '详情地址',
    contactinfo: '联系人信息',
    contactname: '联系人姓名',
    position: '职位',
    selectlabel: '设置标签',
    addcustomer: '添加客户',
    editcustomer: '编辑客户',
    modify1: '修改为已成交',
    modify2: '修改为跟进中',
    nodeal: '跟进中',
    closed: '已成交',
    myclient: '我负责的客户',
    lowerlevel: '我查看的客户',
    placeholder20: '请选择客户范围',
    placeholder21: '请输入客户名称/手机号码',
    customerscope: '客户范围',
    customersearch: '客户搜索',
    addliaison: '添加联系人',
    editliaison: '编辑联系人',
    message06: '你确定要删除该客户吗',
    message07: '你确定要删除该联系人吗',
    message08: '你确定要撤回申请作废吗',
    addcontract: '添加合同',
    placeholder22: '至少选择一项',
    batchtransfersettings: '批量转移设置',
    transfersettings: '转移设置',
    placeholder23: '请确定要撤回该记录吗',
    placeholderOne: '请确定要撤回申请作废记录吗',
    audit: '待审核',
    passed: '已通过',
    fail: '未通过',
    remarkinformation: '备注信息',
    reason: '原因',
    placeholder24: '财务暂未开票',
    notinvoiced: '未开票',
    invoiced: '已开票',
    placeholder25: '请选择要转移的成员',
    customertransfer: '客户转移',
    contracttransfer: '合同转移',
    invoicetransfer: '发票转移',
    unpaid: '未付款',
    uncleared: '未结清',
    settled: '已结清',
    urgentrenewal: '急需续费',
    overdue: '已超期',
    Renewalfee: '待续费',
    norenewal: '无续费',
    contractsettlement: '付款状态',
    contractscope: '合同范围',
    contractsearch: '合同搜索',
    placeholder26: '请输入合同名称',
    placeholder27: '确定要删除该合同吗',
    placeholder28: '请输入合同金额',
    placeholder29: '请选择开始时间',
    placeholder30: '请选择结束时间',
    placeholder31: '请选择续费类型',
    placeholder32: '请输入续费周期',
    placeholder33: '请输入回款金额',
    placeholder34: '请选择回款日期',
    placeholder35: '请输入续费金额',
    placeholder36: '请选择续费结束日期',
    placeholder37: '请输入预计回款金额',
    placeholder38: '请选择回款提醒时间',
    placeholder39: '请选择续费提醒时间',
    placeholder40: '请输入提醒内容',
    placeholder41: '请选择提醒日期',
    money: '金额(元)',
    starttime: '合同开始时间',
    endtime: '合同结束时间',
    amountreceived: '已收款金额',
    paymentstatus: '付款状态',
    follow: '关注',
    personalinvoice: '个人普通发票',
    enterpriseinvoice: '企业普通发票',
    specialinvoice: '企业专用发票',
    collectionrecord: '回款记录',
    collectiondate: '回款日期',
    collectionamount: '回款金额',
    collectionamount01: '预计回款金额',
    addcollection: '添加回款',
    editcollection: '编辑回款',
    addrenewal: '添加续费',
    editrenewal: '编辑续费',
    renewaldate: '续费结束日期',
    renewaldate01: '续费提醒日期',
    renewalamount: '续费金额(元)',
    renewalrecord: '续费记录',
    renewalperiod: '续费周期',
    collectiondate01: '回款提醒日期',
    remindercontent: '提醒内容',
    reminderdata: '提醒时间',
    placeholder42: '请输入发票名称',
    placeholder43: '请填写合同名称',
    placeholder44: '请输入开票金额',
    placeholder45: '请选择发票类型',
    placeholder46: '请输入抬头信息',
    placeholder47: '请输入纳税人识别号',
    placeholder48: '请输入开户行',
    placeholder49: '请输入开户账号',
    placeholder50: '请输入开票地址',
    placeholder51: '请输入电话号码',
    placeholder52: '请输入联系人',
    placeholder53: '请输入联系电话',
    placeholder54: '请选择邮寄方式',
    placeholder55: '请输入邮箱地址',
    placeholder56: '请输入邮寄详细地址',
    placeholder57: '最后跟进时间',
    invoiceinformation: '发票信息',
    headerinformation: '发票类型',
    invoiceheader: '发票抬头',
    paytaxes: '纳税人识别号',
    bankdeposit: '开户行',
    accountnumber: '开户账号',
    billingaddress: '开票地址',
    tel: '电话',
    mailinginformation: '邮寄信息',
    contacts: '联系人',
    contactnumber: '联系电话',
    mailingtype: '发送方式',
    emailaddress: '邮箱地址',
    mailingaddress: '邮寄地址',
    express: '快递',
    mail: '邮件',
    billinginformation: '开票信息',
    invoicingstatu: '开票状态',
    billingdocuments: '开票凭证',
    transactionstatus: '成交状态',
    batchsetlabel: '标签管理',
    placeholder58: '选择的标签不能为空',
    placeholder59: '填写跟进信息',
    placeholder60: '请输入提醒内容',
    placeholder61: '添加跟进提醒',
    placeholder62: '编辑跟进提醒',
    placeholder63: '你确定要删除该数据吗',
    addfile: '添加文件',
    filename: '文件名称',
    uploaduser: '上传用户',
    uploaddate: '上传时间',
    followrecord: '跟进记录',
    contract: '合同',
    paymentrecord: '付款记录',
    paymentreminder: '付款提醒',
    invoice: '发票',
    annexrelated: '附件相关',
    annexrelated12: '你确定要删除该附件吗',
    placeholder64: '请选择合同范围',
    businesstype: '业务类型',
    businesscontent: '业务内容',
    namesearch: '名称搜索',
    Contractpayment: '合同回款',
    applytime: '申请时间',
    relatedcontract: '关联合同',
    invoicing: '开票',
    examine: '审核',
    dutyparagraph: '税号',
    invoicereview: '发票审核',
    placeholder65: '请选择期望开票时间',
    placeholder66: '请输入合同编号',
    contractno: '合同编号',
    fundaudit: '资金审核',
    invoicingapproval: '开票审核',
    labelfiltering: '标签筛选',
    placeholder67: '不能删除审核已通过的内容',
    sendmail: '发送邮件',
    yes: '是',
    no: '否',
    customer: '客户',
    placeholder68: '邮箱不能为空',
    placeholder69: '请输入正确的邮箱格式',
    placeholder70: '请输入有效的电话号码',
    viewcustomer: '查看客户',
    placeholder71: '请输入有效的手机号码',
    placeholder72: '客户邮箱不合法',
    placeholder73: '联系人电话号码不合法',
    placeholder74: '联系人邮箱不合法',
    placeholder75: '请输入搜索的内容',
    placeholder76: '按回车键完成输入',
    collectionreminder: '回款提醒',
    addcollectionreminder: '添加回款提醒',
    editcollectionreminder: '编辑回款提醒',
    collectionremindertime: '回款提醒时间',
    renewalreminder: '续费提醒',
    renewalremindertime: '续费提醒时间',
    addrenewalreminder: '添加续费提醒',
    editrenewalreminder: '编辑续费提醒',
    placeholder77: '请确定要删除该提醒吗',
    placeholder78: '确定要批量删除发票记录吗',
    datechoose: '时间选择',
    departmentchoose: '部门筛选',
    totalincome: '总收入(元)',
    newcustomer: '新增客户(人)',
    newcontract: '新增合同(个)',
    newamount: '新增合同金额(元)',
    uncollectedamount: '至今未回款金额(元)',
    contractrenewal: '合同续费(元)',
    departmentperformance: '部门业绩分析统计',
    contracttype: '合同分类分析统计',
    salestop: '业务员业绩排行榜',
    ranking: '排名',
    completeproportion: '完成占比',
    completeamount: '完成金额(元)',
    totalcontractamount: '总计合同金额(元)'
  },
  calendar: {
    placeholder01: '搜索文档',
    placeholder02: '填写记事本标题',
    placeholder03: '记事本标题',
    placeholder04: '记事本内容',
    placeholder05: '记事本的标题不能为空',
    placeholder06: '记事本的内容不能为空',
    placeholder07: '你确定要删除这条内容吗',
    placeholder08: '你确定要删除分类吗',
    addtype: '添加子分类',
    memorandum: '记事本',
    scheduleview: '日程查看',
    newschedule: '新建日程',
    editchedule: '编辑日程',
    addtask: '添加任务',
    edittask: '编辑任务',
    checktask: '查看任务',
    todocontent: '待办内容',
    remarks: '备注内容',
    repeatreminder: '重复提醒',
    placeholder09: '填写待办内容',
    placeholder10: '请选择提醒方式',
    placeholder11: '选择提醒时间',
    placeholder12: '待办内容不能为空',
    placeholder13: '提醒时间不能为空',
    placeholder14: '请选择结束日期',
    placeholder15: '请选择重复星期',
    placeholder16: '请选择重复天',
    norepetition: '不重复',
    repeatbyday: '按天重复',
    repeatweekly: '按周重复',
    repeatmonthly: '按月重复',
    repeatyear: '按年重复',
    custom: '自定义',
    customrepeat: '自定义重复',
    repetitiontype: '重复类型',
    frequency: '频率',
    weekly: '每周',
    monthly: '每月',
    enddate: '结束日期',
    neverend: '永不结束',
    year: '年',
    placeholder17: '请输入提醒频率',
    newmemo: '新建备忘录',
    newtodo: '新建待办',
    edittodo: '编辑待办'
  },
  business: {
    addBusiness: '新建审批流程',
    businessPic: '审批流图标',
    businessPic1: '审批流图标：',
    businessType: '审批类型',
    businessType1: '审批类型：',
    Range: '发起人范围',
    submissionTime: '提交时间',
    approvalStatus: '审批状态',
    agan: '审批被拒后重新提交',
    basicConfiguration: '基础配置',
    formConfiguration: '表单配置',
    processSetting: '流程配置',
    ruleConfiguration: '规则配置',
    businessTypeIn: '审批类型说明：',
    handle: '异常处理：',
    handle1: '自动同意',
    handle2: '转交给指定人员处理',
    automatic: '自动审批：',
    automatic1: '当同一个审批人重复审批同一单据时',
    automatic2: '仅首个节点需审批，其余自动同意',
    automatic3: '仅连续审批时自动同意',
    automatic4: '每个节点都需要审批',
    editAuthority: '修改权限：',
    editAuthority1: '提交申请时，员工不可修改固定人审批人',
    editAuthority2: '提交申请时，员工不可删除固定抄送人',
    revokeAuthority: '撤销权限：',
    revokeAuthority1: '通过后允许撤销',
    revokeAuthority2: '审批通过后，经审批人同意可撤销',
    refuseAuthority: '审批被拒绝：',
    refuseAuthority1: '返回审批流初始层级，所有审核人需要重新审核',
    refuseAuthority2: '跳过审批流已通过层级，返回拒接的层级',
    changeIcon: '选择图标',
    release: '发布',
    return: '返回',
    message01: '你确定要删除该审批流程吗',
    message10: '你确定要删除该员工吗',
    approval: '办公审批',
    message1: '请输入审批类型',
    message2: '请选择模板图标',
    message3: '请输入审批类型说明'
  }
};